import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-modern-loader',
  templateUrl: './popup-modern-loader.component.html',
  styleUrls: ['./popup-modern-loader.component.scss']
})
export class PopupModernLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
